<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-layout :spacing="8">
      <vc-col :span="12">
        <example-title src="example-1.html" title="Initially hidden overlay" />
      </vc-col>
      <vc-col :span="12">
        <example-title src="example-2.html" title="Initially visible overlay" />
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="12">
        <vc-switcher color="deep-purple" name="switch-1" v-model="loading1">{{ toggleOnOff }}</vc-switcher>
      </vc-col>
      <vc-col :span="12">
        <vc-switcher color="orange" name="switch-1" v-model="loading2">{{ toggleOnOff }}</vc-switcher>
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="12" :class="['container-overlay']">
        <vc-lorem-ipsum :repeats="2" />
        <vc-loading-overlay :visible="loading1" :dark="false" spinnerColor="deep-purple" spinnerSize="large" />
      </vc-col>
      <vc-col :span="12" :class="['container-overlay']">
        <vc-lorem-ipsum :repeats="2" />
        <vc-loading-overlay :visible="loading2" spinnerIcon="hourglass_full" spinnerColor="orange" spinnerSize="normal" />
      </vc-col>
    </vc-layout>
    <vc-layout :spacing="8">
      <vc-col :span="12">
        <example-title src="example-3.html" title="Application overlay" />
        <vc-button color="red" @click="showAppOverlay()">show application overlay for 5 seconds</vc-button>
      </vc-col>
      <vc-col :span="12">
        <example-title src="example-4.html" title="Overlay in dialog" />
        <vc-button color="teal" @click="showOverlayInVcDialog()">show overlay in dialog</vc-button>
      </vc-col>
    </vc-layout>
    <vc-dialog color="teal" :show="dialog" modal @close="dialog = false" width="700px">
      <vc-dialog-header :close-button="true" icon="schedule">Modal dialog with loading overlay</vc-dialog-header>
      <vc-dialog-content>
        <p>You can display the loading overlay while the content of the dialog is being loaded....</p>
        <vc-lorem-ipsum :repeats="3" />
        <vc-loading-overlay :dark="false" :visible="loading3" spinnerColor="teal" spinnerSize="large" />
      </vc-dialog-content>
      <vc-dialog-footer>
        <vc-button color="teal" @click="dialog = false">Close</vc-button>
      </vc-dialog-footer>
    </vc-dialog>
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'PageLoadingOverlay',
  data () {
    return {
      title: null,
      description: null,
      loading1: false,
      loading2: true,
      loading3: true,
      dialog: false,
      toggleOnOff: 'toggle overlay on/off'
    }
  },
  mixins: [
    methods
  ],
  mounted () {
    this.getPage()
  },
  methods: {
    showAppOverlay () {
      const events = this.$store.state.events
      this.$root.$emit(events.ajaxStart)
      setTimeout(() => {
        this.$root.$emit(events.ajaxEnd)
      }, 5000)
    },
    showOverlayInVcDialog () {
      this.dialog = true
    }
  }
}
</script>
<style>
.container-overlay
{
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/pages/loading-overlay.vue